export default "__VITE_PUBLIC_ASSET__5a0b4222__"